export const NO_BALANCE = 0
export const RESP_200 = 200
export const INITIAL_PERIOD_CIERRE_CONTABLE = 2010
